import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * The Footer-Light molecule contains links to others pages.
 *
 * baseUrl - The base Url. Used to build others Url in component.
 * didomiUrl - The Didomi script to launch Cookies modal. If didomiUrl is not set, its link is not shown.
 */
@customElement('nn-footer-light')
export class FooterLight extends LitElement {
  static styles = css`
    :host {
      background: var(--nn-footer-light_host_background, #010101);
      border: 0;
      border-radius: 0;
      box-sizing: border-box;
      display: block;
      font-family: font-light;
      font-size: var(--nn-footer-light_host_font-size, 16px);
      line-height: calc(4px + 2ex);
      margin: 0 auto;
      padding: 0;
      width: 100%;
    }
    #footer-light,
    #footer-light * {
      box-sizing: border-box;
    }
    #footer-light ul,
    #footer-light li {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    #footer-light .container {
      margin: 0 auto;
      max-width: 1470px;
      padding: 0 15px;
      width: 100%;
    }
    #footer-light {
      background: var(--nn-footer-light_footer-light_background, #010101);
      font-family: 'font-light';
      font-size: var(--nn-footer-light_footer-light_font-size, 16px);
      margin: 0;
    }
    #footer-light .category {
      align-items: center;
      display: flex;
      gap: var(--nn-footer-light_footer-light_category_gap, 16px);
      min-height: var(
        --nn-footer-light_footer-light_category_min-height,
        128px
      );
      justify-content: center;
      padding: var(--nn-footer-light_category_padding, 16px 0);
      width: 100%;
    }
    #footer-light .category-item {
      text-align: center;
      position: relative;
    }
    #footer-light .category-item:before {
      color: var(--nn-footer-light_category-item--before_color, #fff);
      content: '-';
      display: inline-block;
      position: absolute;
      left: -10px;
      top: calc(50% - 10px);
    }
    #footer-light .category-item:first-child:before {
      display: none;
    }
    #footer-light .category .anchor,
    #footer-light .category .anchor:active,
    #footer-light .category .anchor:focus,
    #footer-light .category .anchor:visited,
    #footer-light .category .anchor:hover {
      color: var(--nn-footer-light_category_anchor_color, #fff);
      font-size: var(--nn-footer-light_anchor_font-size, 1.175em);
      padding: var(--nn-footer-light_anchor_padding, 8px 0);
      text-align: center;
      text-decoration: none;
      transition: var(--nn-footer-light_anchor_transition, 0.3s);
    }
    #footer-light .category .anchor:hover {
      text-decoration: underline;
    }
    @media (max-width: 1024px) {
      :host {
        --nn-footer-light_anchor_font-size: 0.975em;
      }
    }
    @media (max-width: 900px) {
      :host {
        --nn-footer-light_anchor_font-size: 1em;
      }
      #footer-light .category {
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
      #footer-light .category-item {
        margin: 4px 0;
      }
      #footer-light .category-item:before {
        display: none;
      }
    }
  `;

  @property({ type: String }) baseUrl = 'https://www.nordnet.com';

  @property({ type: String }) didomiUrl = '';
  // i.e. : javascript:Didomi.preferences.show()

  renderDidomiLink() {
    if (this.didomiUrl) {
      return html`
        <li class="category-item">
          <a
            class="anchor"
            title="Gérer les cookies"
            id="footer-manage-cookies"
            href="${this.didomiUrl}"
          >
            Gérer les cookies
          </a>
        </li>
      `;
    }
    return '';
  }

  render() {
    return html`
      <footer id="footer-light" class="footer-light">
        <div class="container">
          <ul class="category">
            <li class="category-item">
              <a
                class="anchor"
                title="Informations légales"
                id="footer-informations-legales"
                href="${this.baseUrl}/informations-legales"
              >
                Informations légales
              </a>
            </li>
            <li class="category-item">
              <a
                class="anchor"
                title="Conditions et récapitulatifs contractuels"
                id="footer-documentation-contractuelle"
                href="${this.baseUrl}/documentation-contractuelle"
              >
                Conditions et récapitulatifs contractuels
              </a>
            </li>
            <li class="category-item">
              <a
                class="anchor"
                title="Données personnelles et cookies"
                id="footer-donnees-personnelles-cookies"
                href="${this.baseUrl}/donnees-personnelles-politique-cookies"
              >
                Données personnelles & cookies
              </a>
            </li>
            ${this.renderDidomiLink()}
          </ul>
        </div>
      </footer>
    `;
  }
}
